// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout {
  display: grid;
  grid-template-columns: 20% 80%;
  color: white;
}
.admin-layout .left-nav {
  height: 100vh;
  background-color: rgb(19, 19, 19);
  color: white;
}
.admin-layout .left-nav ol {
  list-style: none;
  margin-left: 10%;
  margin-right: 10%;
}
.admin-layout .left-nav ol li {
  padding: 10px;
  transition: all 0.2s ease-in-out;
  color: white;
}
.admin-layout .left-nav ol li .left-nav-list-items {
  display: grid;
  grid-template-columns: 20% 80%;
  align-items: center;
}
.admin-layout .left-nav ol li:hover {
  border: 2px solid white;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
